@if (loading) {
    <cb-loading-spinner message="Please wait loading.." class="cb-margin"> </cb-loading-spinner>
}
@if (
    !loading && ((actualCosts$ | async) == null || (actualCosts$ | async)?.buildStages?.length == 0)
) {
    <cb-info-message
        message="There are no Actual Costs for this Lot"
        icon="info_circle"
        class="cb-margin"
    ></cb-info-message>
}
@if (!loading && (actualCosts$ | async)?.buildStages?.length) {
    <div style="margin-bottom: 0" class="top-panel cb-margin end-center flex-row">
        <button
            class="cb-margin-left"
            mat-raised-button
            color="primary"
            (click)="expandCollapseAll()"
        >
            @if (!getAllExpanded()) {
                <span class="start-center flex-row">
                    <span>Expand All&nbsp;</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </span>
            }
            @if (getAllExpanded()) {
                <span class="start-center flex-row">
                    <span>Collapse All&nbsp;</span>
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </span>
            }
        </button>
    </div>
    <mat-accordion [multi]="true" class="accordion cb-padding-bottom">
        @for (stage of (actualCosts$ | async)?.buildStages; track stage) {
            <mat-expansion-panel
                class="panel"
                [(expanded)]="expandedAreas[stage?.label]"
                (expandedChange)="expandedChange()"
            >
                <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                    <mat-panel-title>
                        <span
                            class="mat-body-strong cb-margin-top"
                            [ngStyle]="stage.activities.length < 1 && { opacity: '0.6' }"
                        >
                            {{ stage.label }} ({{ stage.activities.length }})
                        </span>
                    </mat-panel-title>
                    <mat-panel-description class="end-center flex-row"> </mat-panel-description>
                </mat-expansion-panel-header>
                @for (activity of stage?.activities; track activity) {
                    <div class="flex-col">
                        <div class="flex-row" style="margin-top: 16px">
                            <span class="mat-body-strong"
                                >{{ activity.code }} - {{ activity.name }}</span
                            >
                        </div>
                        <cb-table
                            class="cb-margin-top flex"
                            label="Activities"
                            maxHeightOffset="280"
                            [loaded]="true"
                            [(results)]="activity.ssrs"
                        >
                            <thead cbTableHead>
                                <tr>
                                    <td style="width: 15%">Date</td>
                                    <td style="width: 30%">Purchase Order #</td>
                                    <td style="width: 30%">Supplier</td>
                                    <td style="width: 25%">Total</td>
                                </tr>
                            </thead>
                            <tbody cbTableBody>
                                @for (ssr of activity?.ssrs; track ssr) {
                                    <tr>
                                        <cb-td-date [value]="ssr.date"></cb-td-date>
                                        <cb-td-text [value]="ssr.purchaseOrderNumber"></cb-td-text>
                                        <cb-td-text [value]="ssr.supplier"></cb-td-text>
                                        <cb-td-text [value]="ssr.total | cbCurrency"></cb-td-text>
                                    </tr>
                                }
                                <tr>
                                    <td colspan="3"></td>
                                    <td colspan="1">
                                        <span class="mat-body-strong">{{
                                            activity.spent | cbCurrency
                                        }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"></td>
                                    <td colspan="1">
                                        <span class="mat-body-2"
                                            >Activity Remaining:
                                            {{ activity.remaining | cbCurrency }}</span
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </cb-table>
                        @if (activity.ssrs.length < 1) {
                            <span>
                                <mat-icon class="mat-accent">info_circle</mat-icon>
                                &nbsp; There are no activities for this stage
                            </span>
                        }
                    </div>
                }
                <div class="end-center flex-row" style="margin-top: 16px">
                    <div class="flex-col">
                        <span class="mat-body-strong">{{ stage.label }}</span>
                        <span class="mat-body-strong"
                            >Purchase Order Total: {{ stage.total | cbCurrency }}</span
                        >
                        <span class="mat-body-2">Budget: {{ stage.budget | cbCurrency }}</span>
                        <span class="mat-body-2"
                            >Remaining Budget: {{ stage.remaining | cbCurrency }}</span
                        >
                    </div>
                </div>
            </mat-expansion-panel>
        }
    </mat-accordion>
}
